export default {
  mobileDesigns: state =>
    state.designs.length &&
    state.designs
      .filter(x => x.mobile_uiux_design)
      .map(x => ({
        image: x.mobile_uiux_design,
        name: x.name,
        page: x.page,
        type: x.type,
        description: x.description
      })),

  webDesigns: state =>
    state.designs.length &&
    state.designs
      .filter(x => x.web_uiux_design)
      .map(x => ({
        image: x.web_uiux_design,
        name: x.name,
        page: x.page,
        type: x.type,
        description: x.description
      }))
};
